module.exports = __webpack_public_path__ + "static/img/10.146f329.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/10.png
// module id = P9r3
// module chunks = 0